"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeNode = exports.ExplorationNode = exports.Tree = exports.isChoiceOptions = void 0;
function isChoiceOptions(data) {
    return !!data
        && (data.path && typeof data.path === "string")
        && (!!data.data);
}
exports.isChoiceOptions = isChoiceOptions;
var Tree = /** @class */ (function () {
    function Tree(data) {
        this.$root = new TreeNode();
        this.$ptn = { '/': this.$root };
        this.$cd = "/";
        this.$root = new TreeNode(data);
        this.$root.meta.path = "/";
    }
    Tree.prototype.GetNode = function (path) {
        if (path)
            this.$cd = path;
        return this.$ptn[this.$cd];
    };
    Tree.prototype.GetBranch = function (path) {
        path = path || this.$cd;
        return Tree.addParent(this.GetNode(path));
    };
    Tree.addParent = function (node) {
        var parent = node.GetParents();
        return __spreadArrays(parent
            .reduce(function (pr, pa) { return __spreadArrays(pr, Tree.addParent(pa)); }, []), [
            node
        ]);
    };
    Tree.prototype.AddNode = function (parentPath, cpn, data, meta) {
        var path, node;
        if (cpn instanceof TreeNode) {
            node = cpn;
            path = cpn.data.toLowerCase();
        }
        else {
            path = cpn.toLowerCase();
            if (!data)
                node = cpn;
            else
                node = data;
        }
        //todo error if path contain illegal characters
        var $parent = this.GetNode(parentPath);
        // todo error on no parent
        // todo error if path already used
        path = Tree.buildPath(parentPath, path);
        this.$ptn[path] = $parent.addChild(node, __assign(__assign({}, meta), { path: path }));
        return this;
    };
    Tree.buildPath = function (parent, folder) {
        return parent + (parent === '/' ? '' : '/') + folder;
    };
    Tree.prototype.AddNodes = function (parentPath) {
        var _this = this;
        var choices = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            choices[_i - 1] = arguments[_i];
        }
        choices.forEach(function (c) {
            if (typeof c === "string") {
                _this.AddNode(parentPath, c);
            }
            else if (c instanceof TreeNode) {
                _this.AddNode(parentPath, c);
            }
            else {
                var path = c.path, data = c.data, meta = c.meta;
                _this.AddNode(parentPath, path, data, meta);
            }
        });
        return this;
    };
    Tree.prototype.GetChoice = function (path) {
        return this.GetNode(path).GetChoices();
    };
    Tree.prototype.pwd = function () {
        return this.$cd;
    };
    return Tree;
}());
exports.Tree = Tree;
var ExplorationNode = /** @class */ (function () {
    function ExplorationNode(value, next, convert) {
        this.next = [];
        this.value = value;
        this.next = next;
        this.convert = convert;
    }
    ExplorationNode.prototype.Value = function () {
        return this.value;
    };
    ExplorationNode.prototype.Next = function () {
        var _this = this;
        return this.next.map(function (n) { return n instanceof TreeNode ? _this.convert(n) : n; });
    };
    ExplorationNode.prototype.Copy = function () {
        return new ExplorationNode(this.value, [], this.convert);
    };
    ExplorationNode.prototype.Attach = function () {
        var _this = this;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        nodes.forEach(function (n) { return _this.attach(n); });
        return this;
    };
    ExplorationNode.prototype.attach = function (node) {
        if (node !== null) {
            this.next.push(node);
        }
    };
    return ExplorationNode;
}());
exports.ExplorationNode = ExplorationNode;
var TreeNode = /** @class */ (function () {
    function TreeNode($parent, data, meta) {
        this.$parents = [];
        this.$children = [];
        this.meta = {};
        if ($parent instanceof TreeNode)
            this.$parents = [$parent];
        else {
            meta = data;
            data = $parent;
        }
        if (data)
            this.data = data;
        if (meta)
            this.meta = meta;
    }
    //Interface
    TreeNode.prototype.ptcNode = function () {
        return new ExplorationNode(this, this.GetChildren(), function (n) { return n.ptcNode(); });
    };
    TreeNode.prototype.ctpNode = function () {
        return new ExplorationNode(this, this.GetParents(), function (n) { return n.ctpNode(); });
    };
    // Class functions
    TreeNode.prototype.GetChildren = function () {
        return this.$children;
    };
    TreeNode.prototype.GetParents = function () {
        return this.$parents;
    };
    TreeNode.prototype.GetChoices = function () {
        return this.$children.map(function (node) { return node.data; });
    };
    TreeNode.prototype.AddChildren = function () {
        var _this = this;
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        children.forEach(function (child) {
            return _this.addChild(child);
        });
        return this;
    };
    TreeNode.prototype.AddParents = function () {
        var _a;
        var parents = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parents[_i] = arguments[_i];
        }
        (_a = this.$parents).push.apply(_a, parents);
        return this;
    };
    //Utils
    TreeNode.prototype.addChild = function (child, meta) {
        if (child instanceof TreeNode) {
            child.meta = __assign(__assign({}, child.meta), meta);
            child.$parents.push(this);
        }
        else {
            child = new TreeNode(this, child, meta);
        }
        this.$children.push(child);
        return child;
    };
    TreeNode.prototype.removeChild = function (child) {
        var index = this.$children.indexOf(child);
        if (index === -1)
            return;
        this.$children.splice(index, 1);
        child.removeParent(this);
    };
    TreeNode.prototype.removeParent = function ($parent) {
        var index = this.$parents.indexOf($parent);
        if (index === -1)
            return;
        this.$parents.splice(index, 1);
        $parent.removeChild(this);
    };
    return TreeNode;
}());
exports.TreeNode = TreeNode;
